import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonComponent } from '@shared/button/button.component';
import { FormFieldComponent } from '@shared/form-field/form-field.component';
import { OAuthService } from 'angular-oauth2-oidc';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { TextareaModule } from 'primeng/textarea';
import * as Sentry from '@sentry/angular';

@Component({
  selector: 'app-feedback-dialog',
  imports: [FormFieldComponent, TextareaModule, ReactiveFormsModule, ButtonComponent],
  templateUrl: './feedback-dialog.component.html',
  styleUrls: ['./feedback-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeedbackDialogComponent {
  private readonly dynamicDialogRef = inject(DynamicDialogRef);
  private readonly oAuthService = inject(OAuthService);
  message = new FormControl('', Validators.required);

  close(): void {
    this.dynamicDialogRef.close();
  }

  send(): void {
    Sentry.captureFeedback({
      message: this.message.value ?? '',
      name: (this.oAuthService.getIdentityClaims()['name'] as string | undefined) ?? '',
      email: (this.oAuthService.getIdentityClaims()['email'] as string | undefined) ?? '',
    });
    this.dynamicDialogRef.close();
  }
}
